import { Entity } from '../../../../../models';
import { Permission, Permissions } from '../../../../../models/overmind/permissions';
import { TagListItem } from '../../../../../models/tag';
import { GetUserDto } from '../../../../../models/view/employee';

export enum ManagePersonCascadingPanelIds {
  Sections = 'sections',
  Permissions = 'permissions',
}

export interface IManagePersonCascadingPanelsProps {
  learnerSlug: string | undefined;
  onSubmit: () => void;
  onCancel: () => void;
}

export interface IManagePersonFocusPanelProps {
  person: GetUserDto | undefined;
  permissions: Permissions | undefined;
  tags: TagListItem[] | undefined;
  onClickSection: (section: ManagePersonCascadingPanelIds) => void;
  onCancel: () => void;
  onSubmit: (learnerSlug: string) => void;
}

// export interface IManagePersonDetailsLayoutProps {
//   defaultValues: Employee | undefined;
//   onSave: (personSlug: string) => void;
// }
export interface IManagePersonDetailsLayoutProps {
  person: GetUserDto | undefined;
  onSubmit: (personSlug: string) => void;
}

// permissions
export enum ManagePersonPermissionsCascadingPanelIds {
  Sections = 'sections',
  UserManagement = 'userManagement',
  Analytics = 'analytics',
  AssessmentManagement = 'assessmentManagement',
  LearningManagement = 'learningManagement',
  RoleSkillManagement = 'roleSkillManagement',
}

export interface IManagePersonPermissionsCascadingPanelsProps {
  person: GetUserDto | undefined;
  permissions: Permissions | undefined;
  onSave: () => void;
  onCancel: () => void;
}

export interface IManagePersonPermissionsFocusPanelProps {
  person: GetUserDto | undefined;
  permissions: Permissions | undefined;
  onClickSection: (section: ManagePersonPermissionsCascadingPanelIds) => void;
  onCancel: () => void;
}

export interface IManagePersonPermissionFocusPanelProps {
  name: string;
  company: Entity | undefined;
  person: GetUserDto | undefined;
  permission: Permission | undefined;
  onCancel: () => void;
  onSave: () => void;
}

// tags
export interface IManagePersonTagsFocusPanelProps {
  personSlug: string | undefined;
  tags: TagListItem[] | undefined;
  onCancel: () => void;
  setTags: React.Dispatch<React.SetStateAction<TagListItem[] | undefined>>;
}

